module.exports = __webpack_public_path__ + "assets/img/brand-must-be-protected.4710f1bb.svg";